<template>
  <li class="nav-item">
    <router-link
      :to="link.path"
      @click.native="linkClick"
      class="nav-link"
      :class="{ active: isActive }"
      :target="link.target"
      :href="link.path"
      :exact="link.path === '/'"
    >
      <span class="nav-link-content">
        <span class="nav-link-icon">
          <i :class="link.icon || 'fa fa-circle'"></i>
        </span>
        <span class="nav-link-text">{{ link.name }}</span>
      </span>
      <span v-if="link.badge" class="nav-link-badge">{{ link.badge }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'sidebar-item',
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: '',
          path: '',
          children: []
        };
      },
      description:
        'Sidebar link. Can contain name, path, icon and other attributes. See examples for more info'
    }
  },
  inject: {
    autoClose: {
      default: true
    }
  },
  computed: {
    isActive() {
      const currentPath = this.$route && this.$route.path ? this.$route.path : '';
      const linkPath = this.link && this.link.path ? this.link.path : '';

      if (!linkPath) {
        return false;
      }

      if (linkPath === '/') {
        return currentPath === '/';
      }

      return currentPath === linkPath || currentPath.startsWith(`${linkPath}/`);
    }
  },
  methods: {
    linkClick() {
      this.$emit('click');
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>

<style scoped>
.nav-item {
  margin-bottom: 0.18rem;
}

.nav-link {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 2.85rem;
  padding: 0.72rem 0.8rem;
  margin: 0;
  border-radius: 0.35rem;
  color: var(--sidebar-text-strong);
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: 0;
  transition: background-color 0.18s ease, color 0.18s ease;
}

@media (max-width: 767.98px) {
  .nav-item {
    margin-bottom: 0;
  }

  .nav-link {
    min-height: 3.35rem;
    align-items: center;
    padding: 0.72rem 0.9rem;
    border: 1px solid transparent;
    border-radius: 0.75rem;
    font-size: 0.95rem;
    line-height: 1.3;
  }

  .nav-link.active {
    border-color: rgba(53, 106, 230, 0.18);
    box-shadow: 0 0.3rem 0.8rem rgba(15, 23, 42, 0.1);
  }
}

.nav-link:hover,
.nav-link:focus {
  color: var(--sidebar-text-strong);
  text-decoration: none;
  background: var(--sidebar-hover-bg);
  box-shadow: none;
}

.nav-link:focus-visible {
  outline: 2px solid var(--sidebar-active-text);
  outline-offset: 2px;
}

.nav-link.active {
  color: #ffffff;
  font-weight: 700;
  background: #356ae6;
  box-shadow: 0 2px 6px rgba(53, 106, 230, 0.2);
}

.nav-link.active::before {
  display: none;
}

.nav-link-content {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-width: 0;
}

.nav-link-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1.15rem;
  margin-top: 0;
  border-radius: 0;
  background: transparent;
  color: var(--app-muted);
  box-shadow: none;
  flex-shrink: 0;
  font-size: 0.86rem;
}

.nav-link.active .nav-link-icon {
  background: transparent;
  color: #ffffff;
  box-shadow: none;
}

.nav-link-text {
  min-width: 0;
  overflow-wrap: anywhere;
  white-space: normal;
}

.nav-link-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.16rem 0.4rem;
  border-radius: 0.25rem;
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--sidebar-badge-text);
  background: var(--sidebar-badge-bg);
}

.nav-link.active .nav-link-badge {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.18);
}
</style>
